import { faqItems } from '@/mocks/homeData';
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-2">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            关于黑料718网址入口与使用的常见问题解答
          </p>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors duration-200"
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {item.question}
                  </h3>
                  <i
                    className={`text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}